/* Pagina produs Get Nails: checkout personalizat si stare de stoc.
   Nu interactioneaza cu dropdown-urile de descriere/specificatii. */
(() => {
  if (window.__gnProductReferenceInstalled) return;
  window.__gnProductReferenceInstalled = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-gn-buy-now]');
    if (!button || button.disabled || button.dataset.loading === 'true') return;
    const root = button.closest('product-info.gn-pdp-reference');
    const form = button.closest('form[is="product-form"]');
    if (!root || !form) return;
    event.preventDefault();

    const variantId = form.querySelector('input[name="id"]');
    if (!variantId || variantId.disabled || !variantId.value) return;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const originalText = button.textContent;
    button.textContent = button.dataset.gnProcessing || 'Processing...';
    const errorElement = form.querySelector('.product-form__error-message');
    if (errorElement) errorElement.hidden = true;

    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const route = rootPath.endsWith('/') ? rootPath : `${rootPath}/`;
      const response = await fetch(`${route}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || button.dataset.gnAddError || 'The product could not be added to your cart.');
      }
      window.location.assign(`${route}checkout`);
    } catch (error) {
      const message = error.message || button.dataset.gnGenericError || 'Something went wrong. Please try again.';
      if (errorElement) {
        errorElement.textContent = message;
        errorElement.hidden = false;
      } else {
        window.alert(message);
      }
      button.textContent = originalText;
      button.removeAttribute('aria-busy');
      button.disabled = false;
      delete button.dataset.loading;
    }
  });

  // Inainte de raspunsul serverului, noua varianta este in curs de actualizare.
  document.addEventListener('change', (event) => {
    if (!event.target.closest('variant-selects')) return;
    const root = event.target.closest('product-info.gn-pdp-reference');
    const button = root?.querySelector('[data-gn-buy-now]');
    if (button) button.disabled = true;
  });

  // Eveniment existent in product-info.js al temei Get Nails.
  document.addEventListener('variant:changed', (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;
    document.querySelectorAll('product-info.gn-pdp-reference').forEach((root) => {
      const form = root.querySelector('form[is="product-form"]');
      const selectedId = form?.querySelector('input[name="id"]')?.value;
      if (String(selectedId) !== String(variant.id)) return;
      const buyNow = root.querySelector('[data-gn-buy-now]');
      const submitButton = form?.querySelector('.product-form__submit');
      if (buyNow) buyNow.disabled = !variant.available || Boolean(submitButton?.disabled);
      const stockLabel = root.querySelector('[data-gn-stock-label]');
      const stockText = root.querySelector('[data-gn-stock-text]');
      if (stockText) stockText.textContent = variant.available ? (stockText.dataset.gnInStock || 'In stock') : (stockText.dataset.gnOutOfStock || 'Sold Out');
      if (stockLabel) stockLabel.classList.toggle('gn-pdp-stock--unavailable', !variant.available);
    });
  });
})();
